<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				<img src="../../assets/ok.png" >
				<h3>{{msg}}</h3>
				<div class="fcc">
					<div class="button-blue" @click="enter">
						确定
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-pop-success',
		props: {
			msg: {
				type:String,
				default:"成功"
			}
		},
		data() {
			return {
				//timer:null,
				show:true
			}
		},
	
		
		mounted() {
			
		},
		methods: {
			enter(){
				this.$emit('enter-click',false)
			}
		},
		beforeDestroy() {
			//clearTimeout(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
		.inner{
			padding-top: 203px;
			text-align: center;
			img{
				height: 273px;
				margin-bottom: 42px;
			}
			h3{
				font-size: 66px;
				color: #3C90F0;
				line-height: 1.1em;font-weight: bold;
				margin-bottom: 145px;
			}
		}
</style>
